/* eslint-disable  */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { bindActionCreators } from "redux";
import {
  authActionCreators,
  userDataActionCreators,
} from "../../../../service/action-creators";
import Loader from "../../../Loader";
import RenderHome from "../../home/RenderHome";
import "./ApplyLoans.css";
import Loan_chip from "./components/Loan_chip";

const ReadField = ({ label, value }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700">{label}</label>
    <input type="text" readOnly value={value || "N/A"}
      className="mt-1 block w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-md shadow-sm text-sm cursor-not-allowed" />
  </div>
);

function Preview() {
  const dispatch = useDispatch();
  const history = useHistory();

  const { GetFormOneAppliedLoanTemp, ResetUserDataResponse } = bindActionCreators(userDataActionCreators, dispatch);
  const { GetUserProfile } = bindActionCreators(authActionCreators, dispatch);

  const [formState] = useState(6);

  const response = useSelector((state) => state?.user?.response);
  const isLoading = useSelector((state) => state?.user?.isLoading);
  const user = useSelector((state) => state?.auth?.user);
  const userData = useSelector((state) => state?.user);
  const { loanTemp } = userData;

  useEffect(() => { window.scrollTo(0, 0); }, []);

  useEffect(() => {
    GetUserProfile();
    GetFormOneAppliedLoanTemp();
  }, []);

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      ResetUserDataResponse();
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => ResetUserDataResponse(), 1500);
    } else if (response?.state === "DELETED") {
      toast.success(response?.message);
      history.push("/apply-loan-personal_info");
      setTimeout(() => ResetUserDataResponse(), 1500);
    }
  }, [response?.state, response?.message, response?.action]);

  return (
    <div className="ApplyLoans">
      <RenderHome title="Apply Loan">
        {isLoading && <Loader />}

        <Loan_chip formState={formState} />

        <div style={{ maxWidth: "800px", margin: "0 auto", padding: "0 1rem 2rem" }}>

          {/* Personal Information */}
          <div className="bg-white p-6 rounded-lg shadow-md mb-4">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Personal Information</h3>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <ReadField label="Full Name" value={user?.name} />
              <ReadField label="Date of Birth" value={loanTemp?.dateOfBirth} />
              <ReadField label="Age" value={loanTemp?.age?.toString()} />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <ReadField label="SSNIT" value={loanTemp?.ssnit} />
              <ReadField label="ID Type" value={loanTemp?.IdCardType} />
              <ReadField label="ID Number" value={loanTemp?.IDCardNumber} />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <ReadField label="Gender" value={loanTemp?.gender} />
              <ReadField label="Region" value={loanTemp?.region} />
              <ReadField label="Sector" value={loanTemp?.sector} />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <ReadField label="Residential Address (Line 1)" value={loanTemp?.residential_address1} />
                <div className="mt-2"><ReadField label="Line 2" value={loanTemp?.residential_address2} /></div>
              </div>
              <div>
                <ReadField label="Work Address (Line 1)" value={loanTemp?.work_address1} />
                <div className="mt-2"><ReadField label="Line 2" value={loanTemp?.work_address2} /></div>
              </div>
            </div>
          </div>

          {/* Contact Details */}
          <div className="bg-white p-6 rounded-lg shadow-md mb-4">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Contact Details</h3>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <ReadField label="Phone Number" value={loanTemp?.personal_phone} />
              <ReadField label="Work Phone" value={loanTemp?.work_phone} />
              <ReadField label="Email Address" value={loanTemp?.email} />
            </div>
          </div>

          {/* Guarantor 1 */}
          <div className="bg-white p-6 rounded-lg shadow-md mb-4">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Guarantor 1</h3>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <ReadField label="Name" value={loanTemp?.guarantor_name} />
              <ReadField label="Staff ID" value={loanTemp?.guarantor_staff_id} />
              <ReadField label="Phone" value={loanTemp?.guarantor_phone} />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <ReadField label="Ghana Card" value={loanTemp?.guarantor_ghana_card} />
              <ReadField label="GPS Address" value={loanTemp?.guarantor_gps} />
              <ReadField label="Occupation" value={loanTemp?.guarantor_occupation} />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <ReadField label="Mandate Number" value={loanTemp?.guarantor_mandate_number} />
              <ReadField label="OTP Number" value={loanTemp?.guarantor_otp_number?.toString()} />
              <ReadField label="Relationship" value={loanTemp?.guarantor_relationship} />
            </div>
          </div>

          {/* Guarantor 2 */}
          <div className="bg-white p-6 rounded-lg shadow-md mb-4">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Guarantor 2</h3>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <ReadField label="Name" value={loanTemp?.guarantor_name2} />
              <ReadField label="Staff ID" value={loanTemp?.guarantor_staff_id2} />
              <ReadField label="Phone" value={loanTemp?.guarantor_phone2} />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <ReadField label="Ghana Card" value={loanTemp?.guarantor_ghana_card2} />
              <ReadField label="GPS Address" value={loanTemp?.guarantor_gps2} />
              <ReadField label="Occupation" value={loanTemp?.guarantor_occupation2} />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <ReadField label="Mandate Number" value={loanTemp?.guarantor_mandate_number2} />
              <ReadField label="OTP Number" value={loanTemp?.guarantor_otp_number2?.toString()} />
              <ReadField label="Relationship" value={loanTemp?.guarantor_relationship2} />
            </div>
          </div>

          {/* Employment Details */}
          <div className="bg-white p-6 rounded-lg shadow-md mb-4">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Employment Details</h3>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <ReadField label="Employer" value={loanTemp?.employer_name} />
              <ReadField label="Facility" value={loanTemp?.facility} />
              <ReadField label="Staff ID" value={user?.staff_id} />
            </div>
            <div className="mt-4">
              <ReadField label="Employment Start Date" value={loanTemp?.employment_start_date} />
            </div>
          </div>

          {/* Loan Details */}
          <div className="bg-white p-6 rounded-lg shadow-md mb-4">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Loan Details</h3>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <ReadField label="Loan Amount (&#8373;)" value={loanTemp?.loanAmount?.toString()} />
              <ReadField label="Affordability (&#8373;)" value={loanTemp?.affordability?.toString()} />
              <ReadField label="Monthly Deduction (&#8373;)" value={loanTemp?.monthlyDeduction?.toString()} />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <ReadField label="Loan Term (months)" value={loanTemp?.loanTerm?.toString()} />
              <ReadField label="Mandate Number" value={loanTemp?.mandateNumber} />
              <ReadField label="OTP Number" value={loanTemp?.otpNumber?.toString()} />
            </div>
            <ReadField label="Purpose of Loan" value={loanTemp?.purposeForLoan} />
          </div>

          {/* Bank Details */}
          <div className="bg-white p-6 rounded-lg shadow-md mb-4">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Bank Details</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              <ReadField label="Account Holder" value={loanTemp?.bank_account_holder_name} />
              <ReadField label="Bank Name" value={loanTemp?.bank_name} />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <ReadField label="Account Number" value={loanTemp?.bank_account_number} />
              <ReadField label="Bank Branch" value={loanTemp?.bank_branch} />
            </div>
          </div>

          {/* Uploaded Documents */}
          {(loanTemp?.frontIDImage || loanTemp?.passportImage) && (
            <div className="bg-white p-6 rounded-lg shadow-md mb-4">
              <h3 className="text-xl font-semibold mb-4 text-gray-800">Uploaded Documents</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {loanTemp?.frontIDImage && (
                  <div className="border rounded-lg p-3">
                    <p className="text-sm font-medium text-gray-700 mb-2">Ghana Card (Front)</p>
                    <img src={loanTemp.frontIDImage} alt="front-id" className="w-full h-44 object-contain rounded-md" />
                  </div>
                )}
                {loanTemp?.passportImage && (
                  <div className="border rounded-lg p-3">
                    <p className="text-sm font-medium text-gray-700 mb-2">Ghana Card (Back)</p>
                    <img src={loanTemp.passportImage} alt="back-id" className="w-full h-44 object-contain rounded-md" />
                  </div>
                )}
              </div>
            </div>
          )}

          <div className="flex justify-between mt-2">
            <button type="button"
              onClick={() => history.push("/apply-loan-uploads")}
              className="px-6 py-2.5 bg-white text-gray-700 font-medium text-sm rounded-lg border border-gray-400 hover:bg-gray-100 focus:outline-none">
              Back
            </button>
            <button type="button"
              onClick={() => history.push("/apply-loan-terms")}
              className="px-6 py-2.5 bg-green-700 text-white font-medium text-sm rounded-lg hover:bg-green-800 focus:outline-none">
              Next
            </button>
          </div>

        </div>
      </RenderHome>
      <ToastContainer autoClose={3000} />
    </div>
  );
}

export default Preview;
